import { Head, usePage } from '@inertiajs/react';
import { ReactNode } from 'react';

import { TranslationsProvider } from '../../Shared/locale';
import NotificationProvider from '../../Shared/Notifier/NotificationProvider';
import { Charity, User } from '../../Shared/types';
import { PageProps } from '../types';
import { NavBar } from './NavBar';

export default function Layout({
  children,
}: {
  children?: ReactNode;
}) {
  const {
    url, props: { charity, auth: { user } },
  } = usePage<PageProps<{
    charity: Charity | null;
     auth: { user: User | null;
    }
  }>>();

  const segment = url.split('/')[3]?.split(/[?#]/)[0];

  return (
    <TranslationsProvider>
      <NotificationProvider>
        {charity && (
          <Head title={charity.title} />
        )}

        <NavBar charity={charity} user={user} segment={segment} />

        <div className="pt-[60px]">
          {children}
        </div>
      </NotificationProvider>
    </TranslationsProvider>
  );
}
